import * as React from 'react';
import { TagTrailWrapper, Tag, Category, CategoryName, RemoveTag } from './styles';
import { Translate } from 'react-redux-i18n';
import Utils from '../../../utils';
import RoutesUtils from '../../../utils/routes';
import { DriveItemListOrigin, TagMarkers } from '../../../containers/DriveItemListPage/constants';
import UrlUtils from '../../../utils/url';

enum TagType {
	Tag = 'tag',
	Keyword = 'keyword',
}

interface TagTrailProps {
	categorySeparator: string | undefined;
	originParam: string | undefined;
}

interface TagCategory {
	name?: string;
	tags: string[];
}

type StructuredTagTrail = Array<TagCategory>;

const TagTrail = ({ categorySeparator, originParam }: TagTrailProps) => {
	const wrapperElement = React.useRef<HTMLDivElement>(null);

	const setSearchString = (originParam: string | undefined): string | null => {
		if (!originParam) {
			return null;
		}

		const regex = /tags\[(.*)\]/g;
		const match = regex.exec(originParam);
		if (match) {
			return UrlUtils.removeTrailingChar(originParam.replace(match[0], '').trim());
		}
		return originParam;
	};

	const setTagTrailObject = (originParam: string | undefined): StructuredTagTrail | null => {
		if (!originParam) {
			return null;
		}

		let searchTrail = decodeURIComponent(originParam);
		let tagsIndex = searchTrail.indexOf(TagMarkers.Start);
		const structuredTagTrail: StructuredTagTrail = [];

		let tagsString: string | undefined;
		if (tagsIndex !== -1) {
			tagsString = searchTrail.substring(tagsIndex + TagMarkers.Start.length, searchTrail.length - 1);
		}

		if (tagsString) {
			const categories = tagsString.split(',');
			categories.forEach((category) => {
				const tags = category.split('||');
				const tagCategory: TagCategory = {tags: []};
				tags.forEach((tag) => {
					if (!categorySeparator || tag.indexOf(categorySeparator) === -1) {
						tagCategory.tags.push(tag);
						return;
					}

					tagCategory.tags.push(tag.substring(tag.indexOf(categorySeparator) + categorySeparator.length, tag.length));
					if (!tagCategory.hasOwnProperty('name')) {
						tagCategory.name = tag.substring(0, tag.indexOf(categorySeparator));
					}
				});
				structuredTagTrail.push(tagCategory);
			});
			return structuredTagTrail;
		}
		return null;
	};

	const tagTrailToString = (structuredTagTrail: StructuredTagTrail, exclude: string) => {
		const categories: string[] = [];
		structuredTagTrail.forEach((category) => {
			const tagIds: string[] = [];
			category.tags.forEach((tag) => {
				const tagId = category.name && categorySeparator ? category.name + categorySeparator + tag : tag;
				if (tagId && tagId !== exclude) {
					tagIds.push(tagId);
				}
			});
			if (tagIds.length) {
				categories.push(tagIds.join('||'));
			}
		});
		return categories.join(',');
	};

	const handleRemoveTag = (id: string, type: TagType): void => {
		let searchQuery = '';

		if (searchString && type === TagType.Tag) {
			searchQuery += searchString + '&';
		}

		if (structuredTagTrail) {
			const nextTagsString = tagTrailToString(structuredTagTrail, id);
			if (nextTagsString) {
				searchQuery += TagMarkers.Start + nextTagsString + TagMarkers.End;
			}
		}

		if (!searchQuery) {
			return RoutesUtils.historyPush(RoutesUtils.getPathHome());
		}

		window.location.hash = `#${RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Search, encodeURIComponent(UrlUtils.removeTrailingChar(searchQuery)))}`;
	};

	const renderTagElement = (type: TagType, name: string, tagId: string, key?: number) => {
		return (
			<Tag className="Tag" key={key || tagId}>
				{name}
				<RemoveTag onClick={() => handleRemoveTag(tagId, type)}>{Utils.getSvgIcon('iconset_close-1')}</RemoveTag>
			</Tag>
		);
	};

	const renderTagCategories = (category: TagCategory, i: number) => (
		<Category key={i}>
			{category.name && (
				<CategoryName>{category.name}</CategoryName>
			)}
			{category.tags.map((tag, j) => {
				const tagId = category.name && categorySeparator ? category.name + categorySeparator + tag : tag;
				return renderTagElement(TagType.Tag, tag, tagId, j);
			})}
		</Category>
	);

	const searchString = setSearchString(originParam);
	const structuredTagTrail = setTagTrailObject(originParam);

	return (
		<TagTrailWrapper ref={wrapperElement} className="TagTrailWrapper">
			{searchString && (
				<Category>
					<CategoryName>
						<Translate value="messages.search_phrase" />
					</CategoryName>
					{renderTagElement(TagType.Keyword, searchString, searchString)}
				</Category>
			)}
			{structuredTagTrail && structuredTagTrail.map(renderTagCategories)}
		</TagTrailWrapper>
	);
};

export default TagTrail;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/TagTrail/index.tsx